import axios from 'axios';
import { toast } from 'react-toastify';
import {
  EVENTS_ENABLE_ACTION_BEGIN,
  EVENTS_ENABLE_ACTION_SUCCESS,
  EVENTS_ENABLE_ACTION_FAILURE,
  EVENTS_ENABLE_ACTION_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function enableAction(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EVENTS_ENABLE_ACTION_BEGIN,
    });
    const { projectId, eventId, actionId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/events/${eventId}/enable-action/${actionId}`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EVENTS_ENABLE_ACTION_SUCCESS,
            data: res,
          });
          resolve(res);
          if (res.status === 200) {
            dispatch({
              type: EVENTS_ENABLE_ACTION_SUCCESS,
              data: res.data,
              eventId: args.eventId,
            });
            toast.success('Enable/Disabled Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: EVENTS_ENABLE_ACTION_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Enable/Disabled failed: ${errMsg}`);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: EVENTS_ENABLE_ACTION_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Enable/Disabled failed: ${errMsg}`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissEnableActionError() {
  return {
    type: EVENTS_ENABLE_ACTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_ENABLE_ACTION_BEGIN:
      return {
        ...state,
        enableActionPending: true,
        enableActionError: null,
      };

    case EVENTS_ENABLE_ACTION_SUCCESS:
      let events = state.events;
      let index = events.findIndex((item) => {
        return item.uuid === action.eventId;
      });
      events[index] = action.data;
      return {
        ...state,
        enableActionPending: false,
        enableActionError: null,
        events: events,
        selectedEvent: {
          ...state.selectedEvent,
          actions: action.data,
        },
      };

    case EVENTS_ENABLE_ACTION_FAILURE:
      return {
        ...state,
        enableActionPending: false,
        enableActionError: action.data.error,
      };

    case EVENTS_ENABLE_ACTION_DISMISS_ERROR:
      return {
        ...state,
        enableActionError: null,
      };

    default:
      return state;
  }
}
